export enum InboxRadarSortBy {
  LastRunOn = 'lastRunOn',
  InboxScore = 'inboxScore',
  Inbox = 'inbox',
  Spam = 'spam',
  Others = 'others',
  NotDelivered = 'notDelivered',
}

export enum InboxRadarSortOrder {
  Asc = 'asc',
  Desc = 'desc',
}
